<template>
  <footer>
    <div class="container">
      <div class="footer-content">
        <div class="logo">
          <router-link to="/">
            <img :src="footerLogo" alt="China Stroll Logo" />
          </router-link>
        </div>
        <div class="footer-links">
          <p>&copy; 2023 China Stroll. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import footerLogo from '@/assets/images/footer-logo.png'; // Use a logo or copy the existing one

export default {
  name: 'Footer',
  data() {
    return {
      footerLogo,
    };
  },
};
</script>

<style scoped>
footer {
  background-color: #f8f8f8;
  border-top: 1px solid #eaeaea;
  padding: 20px 0;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-content .logo img {
  height: 40px;
}
.footer-links {
  color: #666;
}
.footer-links p {
  margin: 0;
}
</style>